import { OutsideLink } from '@openx/components-core/lib/Link/Link';
import { Trans } from 'react-i18next';

export const NoOptionsInfo = () => (
  <Trans i18nKey="brand_no_options_text_redirect">
    No results matched your search. Please check with{' '}
    <OutsideLink openInNewTab to="https://chatgpt.com/g/g-67964b47fc9c819185a865ab28441a9d-openx-salesforce-admin">
      ChatGPT
    </OutsideLink>{' '}
    what is the Salesforce account creation process.
  </Trans>
);
